import React from 'react';
import Tooltip from '../../Tooltip';
import IconButton from '../../IconButton';
import { ChevronRightSmall, ChevronLeftSmall } from '@wix/wix-ui-icons-common';

import { dataHooks } from '../constants';
import { st, classes } from './ToggleButton.st.css';

export type ToggleButtonProps = {
  minimized: boolean;
  minimizeToggleTooltip?: React.ReactNode;
  onMinimizeToggleClick?: () => void;
  skin?: 'dark' | 'light' | 'neutral';
};

export const ToggleButton: React.FC<ToggleButtonProps> = ({
  minimized,
  minimizeToggleTooltip,
  onMinimizeToggleClick,
  skin,
}) => (
  <Tooltip
    className={st(classes.root, { skin })}
    size="small"
    placement="right-start"
    moveBy={{ x: 6, y: -3 }}
    disabled={!minimizeToggleTooltip}
    content={minimizeToggleTooltip}
    // @ts-expect-error
    style={{ left: 'calc(100% - 12px)' }}
  >
    {/* @ts-ignore */}
    <IconButton
      size="tiny"
      onClick={onMinimizeToggleClick}
      dataHook={dataHooks.minimizeButton}
      className={st(classes.iconButton, { skin })}
    >
      {minimized ? <ChevronRightSmall /> : <ChevronLeftSmall />}
    </IconButton>
  </Tooltip>
);
